import type { StateCreator } from 'zustand';
import type { ViewWindow } from '../../containers/MediaRequestDialog/components/MediaTimelineSlider/utils';
import type { PeriodOption } from '../../containers/MediaRequestDialog/utils';

export interface MediaRequestSliceState {
  periods: PeriodOption[];
  selectedPeriod: [number, number] | null;
  range: [number, number] | null;
  zoomLevel: number;
  viewCenter: number;
  viewWindow: ViewWindow;
  duration: number;
  activeMarkerId: string | null;

  setPeriods: (periods: PeriodOption[]) => void;
  setSelectedPeriod: (period: [number, number]) => void;
  setRange: (range: [number, number] | null) => void;
  setZoomLevel: (zoomLevel: number) => void;
  setViewCenter: (viewCenter: number) => void;
  updateViewCenter: (delta: number) => void;
  setViewWindow: (viewWindow: ViewWindow) => void;
  setDuration: (duration: number) => void;
  setActiveMarkerId: (activeMarkerId: string | null) => void;
  clearZoom: () => void;
  clearTimeline: () => void;
}

const mediaRequestSlice: StateCreator<MediaRequestSliceState> = (set) => ({
  periods: [],
  selectedPeriod: null,
  range: null,
  zoomLevel: 8,
  viewCenter: 50,
  viewWindow: { start: 0, end: 100 },
  duration: 60000,
  activeMarkerId: null,

  setPeriods: (periods: PeriodOption[]) => set({ periods }),
  setSelectedPeriod: (period: [number, number]) => set({ selectedPeriod: period }),
  setRange: (range: [number, number] | null) => set({ range }),
  setZoomLevel: (zoomLevel: number) => set({ zoomLevel }),
  setViewCenter: (viewCenter: number) => set({ viewCenter }),
  updateViewCenter: (delta: number) => set((prev) => ({ viewCenter: prev.viewCenter + delta })),
  setViewWindow: (viewWindow: ViewWindow) => set({ viewWindow }),
  setDuration: (duration: number) => set({ duration }),
  setActiveMarkerId: (activeMarkerId: string | null) => set({ activeMarkerId }),

  clearZoom: () =>
    set({
      zoomLevel: 8,
      viewCenter: 50,
      viewWindow: { start: 0, end: 100 },
    }),

  clearTimeline: () =>
    set({
      selectedPeriod: null,
      range: null,
      zoomLevel: 8,
      viewCenter: 50,
      viewWindow: { start: 0, end: 100 },
      duration: 60000,
      activeMarkerId: null,
    }),
});

export default mediaRequestSlice;
